export const CONTENT_WIDTH = 664;

export const CONTENT_ADAPTIVE_WIDTH_SCALE = 60;

export const APP_BUTTON_BLACKLIST_URLS = [
    '/profile/edit/:profileId',
    '/businesses/edit/:businessId',
];
